export const isPrivateCustomer = (customer: Customer): customer is PrivateCustomer => customer.type === 'private';
export const isBusinessCustomer = (customer: Customer): customer is BusinessCustomer => customer.type === 'business';

export type Customer = {
  type: string;
  customerNumber: string;
};

export type PrivateCustomer = Customer & {
  type: 'private';
  salutation: string;
  title: string;
  firstName: string;
  lastName: string;
};

export type BusinessCustomer = Customer & {
  type: 'business';
  companyName: string;
};
